import React, { useRef, useEffect, useCallback, useState} from 'react';
import Track from 'track/Track.js';
import {connect} from 'react-redux';

const WIDTH = 36;
const MARGIN = 58;

const ScrolledViewPort = ({track, xScale, steps, scroll, currentStep, autoScroll, playing}) => { 
    let [min, setMin] = useState(0);
    let [width, setWidth] = useState(0);
    let widthRef = useRef(0);
    let [mouseOffset, setMouseOffset] = useState(undefined);

    let length = steps ? steps.length : 0;

    if (!autoScroll || !playing || currentStep === undefined) {
    } else {
        // otherwise auto scroll
        let scrollTo = currentStep * xScale * WIDTH - (window.innerWidth - MARGIN)/2.0;
        scroll.current.scrollTo(scrollTo, 0);
    }

    const onMouseDown = useCallback((e) => {
        e.stopPropagation();
        let x = e.clientX - MARGIN;
        let startX = min * (window.innerWidth - MARGIN) / 100.0;
        let offset = x - startX;
        setMouseOffset(offset);
    }, [setMouseOffset, min, xScale]);

    useEffect(() => {
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [mouseOffset, min, setMin, xScale, length]);

    const onMouseUp = useCallback(
        () => setMouseOffset(undefined),
        [setMouseOffset]);

    const onMouseMove = useCallback((e, _mouseOffset=mouseOffset) => {
        if (_mouseOffset !== undefined) {
            let x = e.clientX - MARGIN;
            let goalX = x - _mouseOffset;
            let startRatio = goalX / (window.innerWidth - MARGIN - 240);
            let totalWidth = length * xScale * WIDTH;
            let scrollX = startRatio * totalWidth;
            scroll.current.scroll(scrollX, 0);
        }
    }, [mouseOffset, min, setMin, xScale, length]);
        
    useEffect(() => {
        if (scroll.current) {
            scroll.current.addEventListener("scroll", onScroll);
        }
        return () => scroll.current ? scroll.current.removeEventListener("scroll", onScroll) : [];
    }, [onScroll, setMin, setWidth, xScale, steps]);

    useEffect(() => {
        onScroll();
    }, [xScale, onScroll, length, setWidth, setMin]);

    const onScroll = useCallback((e) => {
        if (!steps) {
            return;
        }
        let totalWidth = steps.length * xScale * WIDTH;
        let startRatio = scroll.current.scrollLeft / totalWidth;
        let width = (window.innerWidth - MARGIN - 240) / totalWidth;
        setMin(startRatio * 100);
        widthRef.current = width * 100;
        setWidth(width * 100);
    }, [setMin, setWidth, xScale, steps]);

    let style = {
        width: widthRef.current + '%',
        left: min + '%'
    };

    return (
          <div
            onMouseDown={onMouseDown}
            style={style} className="scrolled-area"/>);
}

const mapStateToProps = (state, props) => {
    let sequencerEngine = props.track.sequencerEngine;
    if (!props.autoScroll) {
        return {playing: sequencerEngine.playing};
    }
    let resolution = state.sequencer.displayResolution;
    if (props.track.pattern.startStep !== undefined) {
        let trackStep = sequencerEngine.trackStep - props.track.pattern.startStep;
        return {
            currentStep: trackStep
        };
    }
    var currentStep = 
        sequencerEngine.trackStepReal || 0; 

    currentStep = Math.ceil(props.track.getPatternStep(currentStep) /
            (Track.baseResolution.numSteps() /
             state.sequencer.displayResolution.numSteps()));

    return {
        currentStep: currentStep,
        playing: sequencerEngine.playing
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrolledViewPort);
